import { render, staticRenderFns } from "./CtrlJiko.vue?vue&type=template&id=3f20f9c4&scoped=true&"
import script from "./CtrlJiko.vue?vue&type=script&lang=ts&"
export * from "./CtrlJiko.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20f9c4",
  null
  
)

export default component.exports